import React from 'react'
import { getSite, SiteKind } from '../utils/site'
import { PageHeaderProps } from './pageheader/types'
import { PageheaderZEG } from './pageheader/pageheaderZEG'
import { PageheaderNZO } from './pageheader/pageheaderNZO'

const site = getSite()

const headers: Record<SiteKind, React.ComponentType<PageHeaderProps>> = {
  NZO: PageheaderNZO,
  ZEG: PageheaderZEG,
}

export const Pageheader = headers[site]
